import type { ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StarRating } from '@/components/resultList/components/StarRating';
import type { ApiQueryParams, Facet, PaleState, ThunkDispatchFunc } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

const ratingValues: Facet[] = [5, 4, 3, 2, 1].map((v) => ({ value: String(v) }));

const displayValues: Record<string, ReactNode> = Object.fromEntries(
    [1, 2, 3, 4, 5].map((r) => [String(r), <StarRating key={r} id={`hotelRatingFilter-${r}`} rating={r} />]),
);

export const HotelRatingFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();
    const checkboxValues = useSelector((s: PaleState) => s.filters.rating);

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxRating(valueOrMap));
    };

    const fetchResultsProxy: CheckboxDispatchProps['fetchResults'] = (queryParams?: ApiQueryParams) => {
        dispatch(fetchResults(queryParams));
    };

    return (
        <CheckboxFilter
            id="hotelRatingFilter"
            label="Hotellstandard"
            facetList={ratingValues}
            displayValues={displayValues}
            checkboxValues={checkboxValues}
            hideLabel
            checkBoxClick={checkBoxClick}
            fetchResults={fetchResultsProxy}
        />
    );
};
